import React from 'react'

const AsideR = () => {
  return (
    <div className=' md:flex hidden rotate-90'>
      <div className='   motion-safe:hover:scale-110 delay-150 duration-300  
     transform flex text-gray-400'>
      <h4 className='hover:text-emerald-400   ' >geremiararaya@gmail.com</h4>
    </div>

    
    </div>
    
  )
}

export default AsideR